import React, { FC, useEffect } from "react"
import { PageTitle } from "../../../../_metronic/layout/core"
import { CompteInfoPersoEdit } from "../../../modules/compte/components/infoPerso/edit/CompteInfoPersoEdit"
import { useAuth } from "../../../modules/auth"
import DocumentsPerso from "../../../modules/compte/components/documents/DocumentsPerso"
import MyCard from "../../../utils/MyCard"
import DocumentsPro from "../../../modules/compte/components/documents/pro/DocumentsPro"
import CompteInfoFournisseurEditionMode from "../../../modules/compte/components/infoFournisseur/CompteInfoFournisseurEditionMode"
import swal from "sweetalert2"
import { toast } from "react-toastify"
import axios from "axios"
import { API_PREEMBAUCHE_SET_DOSSIER_RECRUTEMENT_AS_COMPLETED_ENDPOINT } from "../../../constants"

function InfoToCompleterAvantDemandeEmbauche() {
     const { currentUser, setCurrentUser } = useAuth()

     const { infoPersoToBeFilled, documentsToBeFilled, infoFournisseurToBeFilled } = useAuth()

     // Dossier is completed and ready to be submited to responsable
     const isSendNotificationForCompletionAvailable =
          infoPersoToBeFilled.length === 0 && documentsToBeFilled.length === 0 && !currentUser?.candidat?.candidat?.isDossierRecrutementFilled

     useEffect(() => {
          // Dossier complété
          if (isSendNotificationForCompletionAvailable) {
               // Scroll to the top
               window.scrollTo({ top: 0, behavior: "smooth" })

               // Swal pour notifier
               handleNotifyResponsableCompletionDossierRecrutement()
          }
     }, [infoPersoToBeFilled, documentsToBeFilled])

     function handleNotifyResponsableCompletionDossierRecrutement() {
          swal.fire({
               icon: "info",
               title: "Votre dossier est complet !",
               html: `
                   <p class="mb-2">
                     Voulez-vous soumettre votre dossier d’embauche.
                   </p>
                   <p class="mb-0 text-muted">
                     Une notification sera envoyée à votre interlocuteur afin de finaliser le processus.
                   </p>
                 `,
               showCancelButton: true,
               confirmButtonText: "Confirmer",
               cancelButtonText: "Annuler",
               showLoaderOnConfirm: true,
               preConfirm: async () => {
                    return axios
                         .post(API_PREEMBAUCHE_SET_DOSSIER_RECRUTEMENT_AS_COMPLETED_ENDPOINT, {})
                         .then(() => {
                              swal.fire({
                                   icon: "success",
                                   title: "Votre dossier a bien été envoyé",
                                   html:
                                        "<div class='mb-2'>Votre interlocuteur a bien été notifié et reviendra vers vous pour valider votre dossier.</div>" +
                                        "<div>Toutefois, vous avez toujours la possibilité d’apporter des modifications à vos informations en cas de besoin.</div>",
                              })

                              setCurrentUser(prev => ({
                                   ...prev,
                                   candidat: {
                                        ...prev?.candidat,
                                        candidat: {
                                             ...prev?.candidat?.candidat,
                                             isDossierRecrutementFilled: true,
                                        },
                                   },
                              }))
                         })
                         .catch(e => {
                              toast.error(e.response.data?.detail, { autoClose: false })
                         })
               },
               allowOutsideClick: () => !swal.isLoading(),
          }).then(result => {
               if (result.dismiss === swal.DismissReason.cancel) {
                    swal.fire({
                         icon: "info",
                         title: "Dossier non envoyé",
                         html: "Vous pouvez toujours envoyer votre dossier plus tard à l’aide du bouton situé en haut des formulaires.",
                    })
               }
          })
     }

     return (
          <>
               <div className={"d-flex justify-content-center"}>
                    <div className={"w-100 w-lg-75 w-xxl-65"}>
                         {!currentUser?.candidat?.candidat?.isDossierRecrutementFilled ? (
                              <>
                                   {isSendNotificationForCompletionAvailable ? (
                                        <>
                                             <div className="mb-4 d-flex justify-content-center">
                                                  <button
                                                       type={"button"}
                                                       className={"btn btn-warning btn-sm btn-pulse d-flex align-items-center"}
                                                       onClick={handleNotifyResponsableCompletionDossierRecrutement}
                                                  >
                                                       ENVOYER MON DOSSIER <span className={"ms-2 fs-5 fas fa-paper-plane"} />
                                                  </button>
                                             </div>
                                        </>
                                   ) : (
                                        <>
                                             {/* Note */}
                                             <div className="alert alert-primary text-dark fw-bold">
                                                  <div className="fs-5 mb-2 d-flex align-items-center">
                                                       <i className="fas fa-sticky-note me-2 text-primary"></i>
                                                       <span className="text-primary">Note importante</span>
                                                  </div>
                                                  <div className="mb-1">
                                                       Merci de compléter le dossier d’embauche (informations personnelles et documents) afin de finaliser votre intégration.
                                                  </div>
                                                  <div>
                                                       Une fois le dossier complété, un bouton apparaîtra pour vous permettre de l'envoyer à votre interlocuteur pour validation.
                                                  </div>
                                             </div>
                                        </>
                                   )}
                              </>
                         ) : (
                              <>
                                   {/* Note */}
                                   <div className="alert alert-success text-dark fw-bold">
                                        <div className="fs-5 mb-2 d-flex align-items-center">
                                             <i className="fas fa-check-circle me-2 text-success"></i>
                                             <span className={"text-success"}>Votre dossier a bien été envoyé !</span>
                                        </div>
                                        <div className="mb-1">Votre interlocuteur a bien été notifié et reviendra vers vous pour valider votre dossier.</div>
                                        <div>Toutefois, vous avez toujours la possibilité d’apporter des modifications à vos informations en cas de besoin.</div>
                                   </div>
                              </>
                         )}

                         <MyCard classNames={"mb-5 mb-xl-10"}>
                              <MyCard.Header classNames={"d-flex"} isCollapseIconShown>
                                   Informations Personnelles
                                   {infoPersoToBeFilled.length > 0 ? (
                                        <span className={"ms-sm-4"}>
                                             <span className="badge badge-light-warning fs-6 badge-sm p-2">
                                                  A compléter <i className={"fas fa-exclamation-circle text-warning ms-2  fs-3"} />{" "}
                                             </span>
                                        </span>
                                   ) : (
                                        <span className={"ms-sm-4"}>
                                             <span className="badge badge-light-success fs-6 badge-sm p-2">
                                                  Rien à ajouter <i className={"fas fa-check-circle text-success ms-2 fs-3"} />{" "}
                                             </span>
                                        </span>
                                   )}
                              </MyCard.Header>
                              <MyCard.Body>
                                   <CompteInfoPersoEdit />
                              </MyCard.Body>
                         </MyCard>

                         {currentUser?.fournisseur?.fournisseur && (
                              <MyCard classNames={"mb-5 mb-xl-10"}>
                                   <MyCard.Header classNames={"d-flex"} isCollapseIconShown>
                                        Informations Société
                                        {infoFournisseurToBeFilled.length > 0 ? (
                                             <span className={"ms-sm-4"}>
                                                  <span className="badge badge-light-warning fs-6 badge-sm p-2">
                                                       A compléter <i className={"fas fa-exclamation-circle text-warning ms-2  fs-3"} />{" "}
                                                  </span>
                                             </span>
                                        ) : (
                                             <span className={"ms-sm-4"}>
                                                  <span className="badge badge-light-success fs-6 badge-sm p-2">
                                                       Rien à ajouter <i className={"fas fa-check-circle text-success ms-2  fs-3"} />{" "}
                                                  </span>
                                             </span>
                                        )}
                                   </MyCard.Header>
                                   <MyCard.Body>
                                        <CompteInfoFournisseurEditionMode />
                                   </MyCard.Body>
                              </MyCard>
                         )}

                         <MyCard classNames={"mb-5 mb-xl-10"}>
                              <MyCard.Header classNames={"d-flex"} isCollapseIconShown>
                                   Documents
                                   {documentsToBeFilled.length > 0 ? (
                                        <span className={"ms-sm-4"}>
                                             <span className="badge badge-light-warning badge-sm fs-6 p-2">
                                                  A compléter <i className={"fas fa-exclamation-circle text-warning ms-2  fs-3"} />{" "}
                                             </span>
                                        </span>
                                   ) : (
                                        <span className={"ms-sm-4"}>
                                             <span className="badge badge-light-success badge-sm fs-6 p-2">
                                                  Rien à ajouter <i className={"fas fa-check-circle text-success ms-2  fs-3"} />{" "}
                                             </span>
                                        </span>
                                   )}
                              </MyCard.Header>
                              <MyCard.Body>
                                   <DocumentsPerso />
                                   {currentUser?.fournisseur?.fournisseur && (
                                        <>
                                             <div className="separator my-5"></div>
                                             <DocumentsPro />
                                        </>
                                   )}
                              </MyCard.Body>
                         </MyCard>
                    </div>
               </div>
          </>
     )
}

const InfoToCompleterAvantDemandeEmbaucheWrapper: FC = () => {
     return (
          <>
               <PageTitle breadcrumbs={[{ title: "Recrutement" }]}>Dossier d'embauche</PageTitle>
               <InfoToCompleterAvantDemandeEmbauche />
          </>
     )
}

export { InfoToCompleterAvantDemandeEmbaucheWrapper }
